<template>
  <el-drawer
    :visible.sync="showDrawer"
    :before-close="handleClose"
    :size="drawerWidth"
    :show-close="false"
    :with-header="false"
  >
    <div class="my-6">
      <div class="flex items-center justify-between border-b pb-6 px-6">
        <h2 class="text-base">Initiator's Details</h2>
        <span @click="handleClose" class="cursor-pointer">
          <close-icon size="h-5 w-5" />
        </span>
      </div>

      <div class="px-4 mt-6">
        <div
          v-for="(item, index) in details"
          :key="index"
          class="flex items-center border-b p-6 font-normal text-sm"
        >
          <span class="text-gray-muted w-1/2">{{ item.label }}</span>
          <span class="text-black-10">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    details: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue')
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '60%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    }
  }
}
</script>
